/**
 * Switch Language based on .env GATSBY_SITE_LANG
 */
import * as React from "react"

export const sitesUrls = (langCode, translatedUrls, langReplace) => {
  // const { i18n } = useTranslation();
  const langCodeSite = process.env.GATSBY_SITE_LANG || "it_IT"

  const sitesList = {
    en_US: {
      url: "https://cdamedia.veneziaunica.it/en/",
    },
    it_IT: {
      url: "https://cdamedia.veneziaunica.it/",
    }
  }

  if (langCode === "all") {
    return sitesList
  } else {
    return sitesList[langCode] || false
  }
}
